export default {
    markers: [
        { 
            id: 0, 
            name: 'Hauts de France',
            slug: 'dunkerque',
            tooltip: {
                title: 'Dunkerque',
                desc: 'La Safer accompagne le Grand Port Maritime de Dunkerque dans la gestion de son patrimoine agricole.',
                placement: 'bottom-left',
            },
            posX: 38, 
            posY: 0,
            thumbnail: 'dunkerque.jpg',
            video_documentary: 'k1VtwmCsIYdbmVvo5b4',
            video_interview: 'k2RFGzs6fDmXyEvoFss',
            color: 'red'
        },

        { 
            id: 1, 
            name: 'Normandie',
            slug: 'caen',
            tooltip: {
                title: 'Caen',
                desc: 'La Safer accompagne les acteurs du territoire pour consommer moins de terres agricoles.',
                placement: 'top-left',
            },
            posX: 23, 
            posY: 13,
            thumbnail: 'caen.jpg',
            video_documentary: 'k4TXfJBWfLKLsQvo5b6',
            video_interview: 'k1blSEO5tnwyVdvpl4p',
            color: 'orange'
        },


        { 
            id: 2, 
            name: 'Île-de-France',
            slug: 'ile-de-france',
            tooltip: {
                title: 'Île-de-France',
                desc: 'La Safer et l\'artisanat : main dans la main pour réhabiliter d\'anciens bâtis agricoles.',
                placement: 'top-left',
            },
            posX: 38, 
            posY: 15,
            thumbnail: 'iledefrance.jpg',
            video_documentary: 'k24oFWsJnUPs0dvo5b3',
            video_interview: 'k2FWi8eDHzDv8jvoFst',
            color: 'green'
        },

        { 
            id: 3, 
            name: 'Bretagne',
            slug: 'sarzeau',
            tooltip: {
                title: 'Sarzeau',
                desc: 'La Safer contribue à préserver le dynamisme de la filière ostréicole.',
                placement: 'top-left',
            },
            posX: 12, 
            posY: 24,
            thumbnail: 'sarzeau.jpg',
            video_documentary: 'k6mIpEiCHtHsLSvnjds',
            video_interview: 'k35Q6JlP5PjRIhvoFsn',
            color: 'red'
        },

        { 
            id: 4, 
            name: 'Pays de la Loire',
            slug: 'marais-poitevin',
            tooltip: {
                title: 'Marais poitevin',
                desc: 'La Safer contribue à la préservation de la faune et de la flore du marais.',
                placement: 'top-left',
            },
            posX: 23, 
            posY: 33,
            thumbnail: 'maraispoitevin.jpg',
            video_documentary: 'k2rBDcs4HndNqEvo5b8',
            video_interview: 'k5HEjlVkCz6YWxvpl4r',
            color: 'orange'
        },

        { 
            id: 5, 
            name: 'Bourgogne Franche-Comté',
            slug: 'doucier',
            tooltip: {
                title: 'Doucier',
                desc: 'La Safer contribue à la restauration d\'une zone humide de grand intérêt.',
                placement: 'top-right',
            },
            posX: 55, 
            posY: 30,
            thumbnail: 'doucier.jpg',
            video_documentary: 'k3rQenOnSm0xOlvnjdv',
            video_interview: 'k1exONZirThnvgvoFsm',
            color: 'green'
        },

        { 
            id: 6, 
            name: 'Centre',
            slug: 'montlouis',
            tooltip: {
                title: 'Montlouis-sur-Loire',
                desc: 'La Safer contribue à la valorisation des chemins ruraux et du patrimoine communal.',
                placement: 'top-left',
            },
            posX: 31, 
            posY: 28,
            thumbnail: 'montlouis.jpg',
            video_documentary: 'k5JylV999kD5cdvobsd',
            video_interview: 'k3vaNsirGdKdY1voFsp',
            color: 'red'
        },

        { 
            id: 7, 
            name: 'Auvergne-Rhône-Alpes (Savoie)',
            slug: 'beaufort',
            tooltip: {
                title: 'Beaufort',
                desc: 'La Safer contribue à la préservation de l\'économie agricole et des paysages.',
                placement: 'top-right',
            },
            posX: 59, 
            posY: 38,
            thumbnail: 'beaufort.jpg',
            video_documentary: 'k6YrZtOXdFDZXgvnjdu',
            video_interview: 'k2yMQKITm86vN2voFsl',
            color: 'orange',
            min_width: 'other-width',
        },

        { 
            id: 8, 
            name: 'Nouvelle-Aquitaine',
            slug: 'saint-yaguen',
            tooltip: {
                title: 'Saint-Yaguen',
                desc: 'La Safer restructure une grosse exploitation pour installer deux jeunes agricultrices.',
                placement: 'top-left',
            },
            posX: 24, 
            posY: 51,
            thumbnail: 'saintyaguen.jpg',
            video_documentary: 'k5HEVTp7aLwOZTvnjdt',
            video_interview: 'k28WkjK3wAn2M8voFsk',
            color: 'green'
        },


        { 
            id: 9, 
            name: 'Grand Est',
            slug: 'soultzmatt',
            tooltip: {
                title: 'Soultzmatt',
                desc: 'La Safer réorganise le parcellaire pour une meilleure cohérence des exploitations.',
                placement: 'top-right',
            },
            posX: 62, 
            posY: 22,
            thumbnail: 'soulzmatt.jpg',
            video_documentary: 'k1ardmYFvcHBxqvo5b5',
            video_interview: 'k5XTHbwQBSR0BBvoFsr',
            color: 'red'
        },

        { 
            id: 10, 
            name: 'Occitanie',
            slug: 'saint-antonin-noble-val',
            tooltip: {
                title: 'Saint-Antonin-Noble-Val',
                desc: 'La Safer contribue à la valorisation de sites remarquables en installant une activité agricole adaptée.',
                placement: 'top-left',
            },
            posX: 34, 
            posY: 43, 
            thumbnail: 'saintantonin.jpg',
            video_documentary: 'k6kvnvtYyDJkL2vo5b7',
            video_interview: 'x7obe6m',
            color: 'red'
        },

        { 
            id: 11, 
            name: 'Provence-Alpes-Côte d’Azur',
            slug: 'grasse',
            tooltip: {
                title: 'Grasse',
                desc: 'La Safer facilite l\'installation d\'un jeune producteur de jasmin en nouant des partenariats.',
                placement: 'top-right',
            },
            posX: 55, 
            posY: 54,
            thumbnail: 'grasse.jpg',
            video_documentary: 'k2EEJ9Na74RAnvvo5b9',
            video_interview: 'k4xDez5hqxujO9vpl4s',
            color: 'orange'
        },

        { 
            id: 12, 
            name: 'Auvergne-Rhône-Alpes (Isère)',
            slug: 'le-gresivaudan',
            tooltip: {
                title: 'Le Grésivaudan',
                desc: 'La Safer est partenaire des élus pour remettre en état des parcelles pour l\'agriculture.',
                placement: 'top-right',
            },
            posX: 57, 
            posY: 46,
            thumbnail: 'gresivaudan.jpg',
            video_documentary: 'k4yr9PqJ5gwti7vnjdr',
            video_interview: 'k3VEgP4g4UMXwUvoFso',
            color: 'red',
            min_width: 'other-width',
        },


        { 
            id: 13, 
            name: 'Corse',
            slug: 'corse',
            tooltip: {
                title: 'Ghisonaccia',
                desc: 'La Safer accompagne des communes dans la valorisation et la maîtrise d\'un vaste domaine agricole.',
                placement: 'top-right',
            },
            posX: 69, 
            posY: 57,
            thumbnail: 'corse.jpg',
            video_documentary: 'kRHJzwaew6ipWNvnjdx',
            video_interview: 'kxLAx6WGivRFfMvoFsq',
            color: 'green'
        },

    ],
}
